import { useCallback } from "react";

import { Alert } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { transformArrayDataToSelectOptions } from "@/_helpers/arrayTransformHelper";
import Loader from "@/common/components/Loader";
import { billingDayOptions } from "@/common/constants";
import { useGetUserType } from "@/modules/auth/hooks/userType.hooks";
import AgencyForm from "@/modules/profile/components/AgencyForm";
import {
  useCreateAgency,
  useUpdateAgency,
  useGetAgencyById,
} from "@/modules/profile/hooks/agency.hooks";
import { useGetAllOfferTypes } from "@/modules/profile/hooks/offerType.hooks";

const AgencyContainer = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const readOnlyFromUrl = urlParams.get("readOnly") === "true";

  const {
    state: { readOnly: stateReadOnly, parentId: groupId } = {
      readOnly: false,
      parentId: undefined,
    },
  } = location as {
    state?: {
      readOnly: boolean;
      parentId: string;
    };
  };

  const readOnly = readOnlyFromUrl || stateReadOnly;

  const { mutate: createAgency, isLoading: isLoadingCreateAgency } =
    useCreateAgency({
      handleSuccess: (data) =>
        toast.success(`L'agence ${data?.label} a bien été ajouté !`),
    });

  const { mutate: updateAgency, isLoading: isLoadingUpdateAgency } =
    useUpdateAgency({
      handleSuccess: (data) =>
        toast.success(`L'agence ${data?.label} a bien été mise à jour !`),
    });

  const { data, isLoading, error } = useGetAgencyById(id);

  const { data: offerTypes, isLoading: isLoadingOfferTypes } =
    useGetAllOfferTypes();

  const { isLegimetrie } = useGetUserType();

  const allOfferTypeOptions = transformArrayDataToSelectOptions(
    offerTypes?.offerTypes
  );

  const filteredOfferOptions = allOfferTypeOptions?.filter(
    (item) =>
      item?.label?.toLowerCase() !== "oiko" &&
      item?.label?.toLowerCase() !== "comtesse" &&
      item?.label?.toLowerCase() !== "lamy"
  );

  // force rerender form with new data
  const UpdateFormRender = useCallback(
    () => (
      <AgencyForm
        groupId={groupId}
        defaultValues={data}
        readOnly={readOnly}
        isLoadingOfferTypeData={isLoadingOfferTypes}
        isLoadingCreateAgency={isLoadingCreateAgency}
        isLoadingUpdateAgency={isLoadingUpdateAgency}
        offerTypeOptions={
          !isLegimetrie ? filteredOfferOptions : allOfferTypeOptions
        }
        billingDayOptions={billingDayOptions}
        createAgency={createAgency}
        updateAgency={updateAgency}
      />
    ),
    [data, allOfferTypeOptions, filteredOfferOptions, readOnly]
  );

  if (!id) {
    return (
      <AgencyForm
        groupId={groupId}
        isLoadingOfferTypeData={isLoadingOfferTypes}
        isLoadingCreateAgency={isLoadingCreateAgency}
        isLoadingUpdateAgency={isLoadingUpdateAgency}
        offerTypeOptions={
          !isLegimetrie ? filteredOfferOptions : allOfferTypeOptions
        }
        billingDayOptions={billingDayOptions}
        createAgency={createAgency}
        updateAgency={updateAgency}

      />
    );
  }

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    console.log(`Error Fetch Agency id => ${id} :`, error);
    return (
      <Alert variant="danger">
        Impossible de récupérer les informations de l'agence.&nbsp; Veuiller
        contacter votre administrateur système.
      </Alert>
    );
  }

  if (!data) {
    return (
      <Alert variant="danger">
        Erreur de récupération des données : Veuillez réessayer ultérieurement.
      </Alert>
    );
  }

  return <UpdateFormRender />;
};

export default AgencyContainer;
